import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Chapter } from "@mikros/library";
import {
  Checkbox,
  CheckboxChangeEvent,
  TextArea,
} from "@progress/kendo-react-inputs";
import { SortableItemUIProps } from "@progress/kendo-react-sortable";
import { useEffect, useRef, useState } from "react";

export interface PdfChaptersProps extends SortableItemUIProps {
  handleChecked: (chapterId: string) => void;
  reqListChapters: string[];
  enableDrag: boolean;
  handleEnableDrag: (e: boolean) => void;
}

export function PdfChapters(props: PdfChaptersProps) {
  const { style, attributes, dataItem, forwardRef } = props;
  const sampleRef = useRef();

  const [show, setShow] = useState<boolean>(false);
  const [checked, setChecked] = useState<boolean>(true);
  const [chapterData, setChapterData] = useState<Chapter>(dataItem);

  useEffect(() => {
    console.log("inside use effect of check pdf");
    setChapterData(dataItem);
    if (props.reqListChapters.includes(dataItem.chapterId)) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [dataItem]);

  useEffect(() => {
    props.handleEnableDrag(props.enableDrag);
  }, [props.enableDrag]);

  return (
    <div
      ref={props.enableDrag ? forwardRef : sampleRef}
      {...attributes}
      style={
        props.enableDrag
          ? {
              ...style,
            }
          : {}
      }
      className="mx-2"
    >
      {/* <div
        className={`w-full mb-4 bg-mk-primary-20 ${
          show ? "rounded-3xl" : "rounded-full hover:shadow-xl"
        } space-y-3 px-5 p-3 flex flex-col justify-center items-start`}
      > */}

      <div
        className={`w-full mb-4 
            ${checked ? "bg-mk-primary-50" : "bg-mk-primary-20"}
            ${
              show ? "rounded-3xl" : "rounded-full hover:shadow-xl"
            } space-y-3 px-5 p-3 flex flex-col justify-center items-start
        `}
      >
        <div
          className="w-full flex justify-between items-center"
          onClick={() => props.handleEnableDrag(false)}
        >
          <div className="flex place-items-center space-x-2 justify-center items-center">
            <div>
              <Checkbox
                value={checked}
                onChange={(e: CheckboxChangeEvent) => {
                  setShow(e.value);
                  setChecked(e.value);
                  props.handleChecked(chapterData.chapterId);
                }}
              ></Checkbox>
            </div>
            <FontAwesomeIcon
              icon={["far", "fa-arrows-up-down-left-right" as IconName]}
              className="h-4 w-4 hover:cursor-grab mx-3 text-mk-primary-bright flex-shrink-0"
              onMouseEnter={(e) => {
                e.stopPropagation();
                props.handleEnableDrag(true);
              }}
            />
            {/* <div
              className="editable-div p-1 bg-mk-primary-50 rounded-lg md:text-sm sm:text-[12px] px-2"
              contentEditable={false}
              onMouseEnter={(e) => {
                props.handleEnableDrag(false);
              }}
            > */}
            <div
              className={`editable-div p-1 rounded-lg md:text-sm sm:text-[12px] px-2
             ${
               checked
                 ? "bg-mk-primary font-bold"
                 : "bg-mk-primary-50 font-bold"
             }
              `}
              contentEditable={false}
              onMouseEnter={(e) => {
                props.handleEnableDrag(false);
              }}
            >
              {chapterData.chapterName}
            </div>
          </div>
          {checked ? (
            <div onClick={() => setShow(!show)}>
              <FontAwesomeIcon
                icon={["fas", "fa-play" as IconName]}
                className={`h-4 w-4 mx-3  hover:cursor-pointer text-mk-primary-bright ${
                  !show ? "" : "rotate-90"
                }`}
                onClick={() => props.handleEnableDrag(false)}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className={show ? "rounded-full w-[50%]" : "hidden"}>
          <TextArea
            disabled={true}
            cols={90}
            rounded={"large"}
            contentEditable={false}
          >
            {chapterData.description}
          </TextArea>
        </div>
      </div>
    </div>
  );
}
